export const getPrice = (price: string | number = '0', currencyCode = 'USD') =>
  Intl.NumberFormat(undefined, {
    currency: currencyCode,
    minimumFractionDigits: 0,
    style: 'currency',
  }).format(parseFloat(price.toString()))
